import { hasPermission } from '@/hooks/useBackendMenu'
import { StatusAprovacao } from '@acme/core'
import Dialog from 'global/guides/Dialog'
import { useParams } from 'react-router-dom'
import FormDetalhesAbono from '../forms/DetalhesAbono'
import { useDigitacaoDataContext } from '../pages/useDigitacaoData'
import useService from '../service'
import { funcionarioPodeSolicitarAjustes } from './DetalhesRegistros'

export default function DetalhesAbono() {
    const {
        handleAprovar,
        handleExcluir,
        handleReprovar,
        handleAtualizarAbono,
    } = useService()
    const { id } = useParams()
    const {
        context: { data },
    } = useDigitacaoDataContext()

    const abono = data?.find(({ abono }) => abono?.id === Number(id))?.abono

    const funcionarioPodeAjustar = funcionarioPodeSolicitarAjustes()

    if (!abono) return null

    return (
        <Dialog.Root
            disableFields={!hasPermission(['update', 'Abonos'])}
            defaultValues={abono}
            onDelete={
                hasPermission(['delete', 'Abonos']) || funcionarioPodeAjustar
                    ? ({ motivo }) =>
                          handleExcluir('ABONO', {
                              ...abono,
                              motivo,
                          })
                    : undefined
            }
            validateOnDelete={
                abono?.statusAprovacao != StatusAprovacao.PENDENTE
            }
            onSubmit={
                hasPermission(['update', 'Abonos'])
                    ? handleAtualizarAbono
                    : undefined
            }
            height="auto"
        >
            <Dialog.Title>Detalhes do abono</Dialog.Title>
            <Dialog.Content dividers>
                <FormDetalhesAbono />
                <Dialog.Content.Footer
                    onApprove={
                        hasPermission(['update', 'Abonos'])
                            ? () => handleAprovar('ABONO', abono)
                            : undefined
                    }
                    onReject={
                        hasPermission(['update', 'Abonos'])
                            ? ({ motivo }) =>
                                  handleReprovar('ABONO', {
                                      id: abono.id,
                                      motivo,
                                  })
                            : undefined
                    }
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
